import { MEASUREMENT_TYPES } from "../../../config/enums/MeasurementTypes";

const unitToKgConversion: Record<number, number> = {
  [MEASUREMENT_TYPES.WEIGHT_TON]: 1000,
  [MEASUREMENT_TYPES.WEIGHT_GRAM]: 1 / 1000,
  [MEASUREMENT_TYPES.WEIGHT_KG]: 1
};

export const convertAnyToKg = (unitType: number, unitValue: number): number => {
  const conversionFactor = unitToKgConversion[unitType] ?? 1;
  return unitValue * conversionFactor;
};
